<div class="header-container">
  <div class="header-content">
    <!-- Botón de regreso alineado a la izquierda -->
    <div class="left-section">
      <app-button-goback [returnUrl] ="returnUrl" ></app-button-goback>
      <span class="title-text">{{ titulo }}</span>
    </div>
  </div>
</div>
